module.exports = __webpack_public_path__ + "media/img/frontend_application/laptop-20990e91fb577053ebb0af2cd36ff42c.png";